import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import Card from './Card'
import Layout from '../../../components/Layout'
import { childVariants } from '../../../framerOptions'
import { Col, Row } from 'rsuite'

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  }
}

export default function Program ({ activities }) {
  if (activities && activities.length > 0) {
    return (
     <Container variants={itemVariants}>
       <motion.div variants={childVariants}>
          <Layout.Title>Actividades</Layout.Title>
        </motion.div>
        
          <Row>
          {activities.map((activity, index) => (
            <Col key={index} xs={24} sm={24} md={12}>
              <Card
                key={index}
                name={activity.Name}
                description={activity.Description}
                endsAt={activity.EndsAt}
                startsAt={activity.StartsAt}
                location={activity.Location}
              />
            </Col>
          ))}
          </Row>
       
     </Container>
    )
  } else {
    return null
  }
}

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  margin: 5rem 0;
`